import { Box, Button, Dialog, Portal } from '@chakra-ui/react'
import { useState } from 'react'
import { useBoolean } from 'react-use'
import { TextArea } from 'uikit'
import useDeclineIdentification from './services/useDeclineIdentification'

export const DeclineIdentificationModal = ({ userId }) => {
  const [isOpen, setIsOpen] = useBoolean(false)
  const { mutate: decline, isPending: isLoading } = useDeclineIdentification(userId)
  const [commentValue, setCommentValue] = useState('')

  const handleSubmit = () => {
    const payload = {
      identificationSupportComment: commentValue,
    }
    decline(payload, {
      onSuccess: () => {
        setIsOpen(false)
      },
    })
  }

  return (
    <>
      <Button width="100%" onClick={() => setIsOpen(true)} colorPalette="orange" variant="outline">
        Отклонить
      </Button>
      <Dialog.Root open={isOpen} onOpenChange={(e) => setIsOpen(e.open)}>
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header>
                <Dialog.Title>Отклонение идентификации</Dialog.Title>
                <Dialog.CloseTrigger mt={1} />
              </Dialog.Header>
              <Dialog.Body>
                <TextArea
                  value={commentValue}
                  onChange={(e) => setCommentValue(e.target.value)}
                  placeholder="Введите комментарий"
                />
                <Box pt="30px">
                  <Button
                    colorPalette="orange"
                    loading={isLoading}
                    onClick={handleSubmit}
                    disabled={commentValue === ''}
                  >
                    Отклонить
                  </Button>
                </Box>
              </Dialog.Body>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  )
}
